import React from "react";

import { FilterX } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { JSX } from "react";

function NotFilterableByOfferHint(): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  return (
    <span className="text-muted-foreground inline-flex items-center gap-1 text-xs">
      <FilterX aria-hidden className="size-3.5" />
      {t("charts.notFilterableByOffer")}
    </span>
  );
}

export default NotFilterableByOfferHint;
